/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NoResultsFoundIcon extends BaseIcon {
    getChildren = () => [
        <g>
            <g>
                <g>
                    <g>
                        <path d="M40.133 45.625a9.375 9.375 0 109.375-9.375 9.374 9.374 0 00-9.375 9.375z" fill={this.getColor()}/>
                    </g>
                    <g fill="#fff">
                        <path d="M48.833 49.745a4.795 4.795 0 114.8-4.8 4.8 4.8 0 01-4.8 4.8zm0-8.027a3.232 3.232 0 103.233 3.231 3.236 3.236 0 00-3.233-3.23z"/>
                        <path d="M54.195 51.094a.785.785 0 01-.553-.228l-2.523-2.525a.781.781 0 011.1-1.1l2.525 2.523a.781.781 0 01-.553 1.334z"/>
                    </g>
                </g>
                <g>
                    <path d="M38.571 55h-24.51a2.872 2.872 0 01-2.834-2.9V7.888A2.858 2.858 0 0114.046 5h24.231a2.811 2.811 0 012 .845l7.63 7.818a2.881 2.881 0 01.82 2.017v16.875a.781.781 0 11-1.562 0V15.68a1.324 1.324 0 00-.377-.927l-7.627-7.817a1.24 1.24 0 00-.884-.373H14.046a1.293 1.293 0 00-1.256 1.325V52.1a1.309 1.309 0 001.272 1.341h24.509a.7815.7815 0 010 1.563z" fill={this.getColor()}/>
                </g>
            </g>
            <path fill="none" d="M0 0h60v60H0z"/>
        </g>
    ]
    getViewBox = () => '0 0 60 60'
}
